import { z } from "zod";
import iconDark from "@/assets/icons/icon-dark.svg";
import iconLight from "@/assets/icons/icon-light.svg";

const appConfigJson = {
  app: {
    name: "Scuba Diving Center Arapya",
    icon: {
      light: iconDark,
      dark: iconLight,
    },
  },
};

const config = z
  .object({
    app: z.object({
      name: z.string(),
      icon: z.object({
        light: z.string(),
        dark: z.string(),
      }),
    }),
  })
  .parse(appConfigJson);

export default config;
